export const headline = {
  h1: `
    font-size: 3rem;
    line-height: 3.4rem;
  `,
  h2: `
    font-size: 2.2rem;
    line-height: 2.6rem;
  `,
  h3: `
    font-size: 1.8rem;
    line-height: 2.2rem;
  `,
  h4: `
    font-size: 1.6rem;
    line-height: 2rem;
  `,
  h5: `
    font-size: 1.4rem;
    line-height: 1.8rem;
  `,
};

export const text = {
  large: `
    font-size: 1.8rem;
    line-height: 2.6rem;
  `,
  medium: `
    font-size: 1.6rem;
    line-height: 2rem;
  `,
  normal: `
    font-size: 1.4rem;
    line-height: 2.0rem;
  `,
  small: `
    font-size: 1.2rem;
    line-height: 1.8rem;
  `,
};

export const italic = {
  large: `
    font-style: italic;
    ${text.large}
  `,
  medium: `
    font-style: italic;
    ${text.medium}
  `,
  normal: `
    font-style: italic;
    ${text.normal}
  `,
  small: `
    font-style: italic;
    ${text.small}
  `,
};

export const button = {
  normal: `
    font-size: 1.4rem;
    line-height: 1;
  `,
  medium: `
    font-size: 1.2rem;
    line-height: 1;
  `,
};

export const link = {
  large: `
    font-size: 1.6rem;
    line-height: 2.4rem;
  `,
  normal: `
    font-size: 1.4rem;
    line-height: 2rem;
  `,
  medium: `
    font-size: 1.2rem;
    line-height: 1.8rem;
  `,
  small: `
    font-size: 1rem;
    line-height: 1.4rem;
  `,
};
